sn-long-content-type-3 {
  display: block;

  .sn-long-content-type-3__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;
    margin-bottom: $spacing-3xl;
  }

  .sn-long-content-type-3__title {
    font-size: 1.75rem;
    font-weight: 700;
    line-height: 1.2;
    color: $text-color-primary;
    margin: 0 0 $spacing-lg;
    text-align: center;

    @include desktop-lg {
      font-size: 2.25rem;
    }
  }

  .sn-long-content-type-3__subtitle {
    color: $text-color-tertiary;
    margin: 0 auto;
    max-width: 640px;
    line-height: 1.6;
    text-align: center;
  }

  // ── Tab list (left column) ───────────────────────────────────────────

  .sn-long-content-type-3__tabs {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: $spacing-md;
  }

  .sn-long-content-type-3__tab-wrapper {
    display: flex;
    flex-direction: column;

    &--active {
      .sn-long-content-type-3__tab-item::before {
        background-color: $color-brand-primary-main;
      }

      .sn-long-content-type-3__tab-icon {
        transform: rotate(180deg);
      }

      // Mobile: expand accordion content
      .sn-long-content-type-3__tab-content {
        grid-template-rows: 1fr;
      }

      .sn-long-content-type-3__tab-content-inner {
        padding-bottom: $spacing-xl;
      }
    }
  }

  .sn-long-content-type-3__tab-item {
    position: relative;
    overflow: hidden;
    border-radius: 0 $radius-size-md $radius-size-md 0;
    box-shadow: 0 2px 20px 0 rgb(0 0 0 / 15%);
    background: var(--background-color-primary, #FFF);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: var(--border-color-secondary, #C7CED3);
      transition: background-color 0.15s ease;
    }

    &:hover {
      box-shadow: 0 8px 40px 0 rgb(0 0 0 / 15%);

      &::before {
        background-color: var(--action-color-brand-primary-hover, #348FD7);
      }
    }
  }

  .sn-long-content-type-3__tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    padding: $spacing-lg $spacing-lg $spacing-lg calc(4px + #{$spacing-lg});
    font-size: 1rem;
    font-weight: 600;
    color: $text-color-primary;
    cursor: pointer;
    line-height: 1.4;

    @include desktop-lg {
      padding-top: $spacing-xl;
      padding-bottom: $spacing-xl;
    }
  }

  .sn-long-content-type-3__tab-label {
    flex: 1;
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, md);
    font-weight: map-get($font-weights, bold);
  }

  .sn-long-content-type-3__tab-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: $spacing-md;
    transition: transform 0.2s ease;

    @include desktop-lg {
      display: none !important;
    }
  }

  // ── Mobile accordion content ─────────────────────────────────────────

  .sn-long-content-type-3__tab-content {
    display: grid;
    grid-template-rows: 0fr;
    overflow: hidden;
    transition: grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1);

    @include desktop-lg {
      display: none !important;
    }
  }

  .sn-long-content-type-3__tab-content-inner {
    min-height: 0;
    overflow: hidden;
    transition: padding-bottom 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    padding-top: $spacing-md;
  }

  // ── Desktop right panel ──────────────────────────────────────────────

  .sn-long-content-type-3__right-column {
    display: none !important;

    @include desktop-lg {
      display: block !important;
    }
  }

  .sn-long-content-type-3__panel {
    display: block;
  }

  // ── Shared panel content styles ──────────────────────────────────────

  .sn-long-content-type-3__panel-heading {
    font-size: 1.25rem;
    font-weight: 700;
    color: $text-color-primary;
    margin: 0 0 $spacing-xl;
    line-height: 1.3;
  }

  .sn-long-content-type-3__panel-body {
    h2,
    h3,
    h4 {
      font-size: map-get($font-sizes, md);
      font-weight: 700;
      color: $text-color-primary;
      margin: $spacing-lg 0 $spacing-sm;
      line-height: 1.4;
    }

    p {
      color: $text-color-primary;
      margin: 0 0 $spacing-md;
      line-height: 1.6;
    }

    ol,
    ul {
      margin: 0 0 $spacing-md;
      padding-left: $spacing-xl;
      color: $text-color-primary;
      line-height: 1.6;
    }

    li {
      margin-bottom: $spacing-sm;
    }

    strong {
      font-weight: 700;
    }

    em {
      font-style: italic;
    }
  }

  .me-container {
    padding-top: 0;

    @include desktop-lg {
      padding-bottom: $spacing-7xl;
    }
  }
}
